import { useNavigate } from "react-router-dom";
import {trackClick} from "../api/analytic";


const Footer = () => {
    const navigate = useNavigate();
    return <footer className="footer">
        <div className="container">
            <div className="footer-content">
                <div className="footer-section">
                    <h3>AI Cards: Learn & Speak</h3>
                    <p>AI Cards is designed to break the language barrier. We combine smart learning mechanics with engaging AI companions to make mastering Japanese natural, effective, and fun.</p>
                    <p>日本語を話そう</p>
                </div>
                <div className="footer-section">
                    <h4>Quick Links</h4>
                    <button onClick={() => { }} className="footer-link">
                        <a href="https://play.google.com/store/apps/details?id=com.cardapp.learn.ai" className="footer-link">Google Play Store</a>
                    </button>
                    <button onClick={() => {
                       trackClick("privacy")
                        navigate('/privacy')
                    }}
                    className="footer-link">Privacy Policy</button>
                    <button onClick={() =>{
                        trackClick("terms")
                        navigate('/terms')}} className="footer-link">Terms of Service</button>
                    <button onClick={() =>{
                        trackClick("contactform")
                        navigate('/contact-us')}} className="footer-link"> Contact us</button>
                </div>
                <div className="footer-section">
                    <h4>Media</h4>
                    <div className="social-links">
                        <a
                            onClick={() => {
                                trackClick("googleplay")
                            }}
                            href="https://play.google.com/store/apps/details?id=com.cardapp.learn.ai" className="social-circle" target="_blank" rel="noopener noreferrer" aria-label="Google Play">
                            <svg viewBox="0 0 512 512"><path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z" /></svg>
                        </a>
                        <a
                            onClick={() => {
                                trackClick("reddit")
                            }}
                            href="https://www.reddit.com/r/learn_and_speak_ai" className="social-circle" target="_blank" rel="noopener noreferrer" aria-label="Reddit">
                            <svg viewBox="0 0 512 512"><path d="M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.3-52.6-25.2-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-46.1 17.9-46.9 17.9s-28.8.3-46.9-17.9c-3.1-3.1-3.1-8.3 0-11.4 3.1-3.1 8.3-3.1 11.4 0 12.7 12.7 29.1 12.7 35.5 12.7 6.4 0 22.7-.3 35.5-12.7 3.1-3.1 8.3-3.1 11.4 0 3.1 3.1 3.1 8.3 0 11.4zm1.9-65.7c-13.6 0-24.6-11.1-24.6-24.9 0-13.6 11.1-24.6 24.6-24.6 13.8 0 24.9 11.1 24.9 24.6 0 13.8-11.1 24.9-24.9 24.9z" /></svg>
                        </a>
                        <a
                            onClick={() => {
                                trackClick("youtube")
                            }}
                            href="https://www.youtube.com/@AICardsLearnSpeak" className="social-circle" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                            <svg viewBox="0 0 576 512"><path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.781 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" /></svg>
                        </a>
                        <a
                            onClick={() => {
                                trackClick("linkedin")
                            }}
                            href="https://www.linkedin.com/company/ai-cards-learn-speak" className="social-circle" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                            <svg viewBox="0 0 448 512"><path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" /></svg>
                        </a>
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <p>&copy; 2026 AI Cards: Learn & Speak. All rights reserved.</p>
            </div>
        </div>
    </footer>
}
export default Footer
